import React, { useContext, useEffect } from 'react';
import { Select } from 'antd';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';
import Field from '../../../../shared/ui/Field';
import { useFieldController } from '../../../../../../helpers/formManager';
import { contextNames, contexts } from '../../services/propsProvider';

const BaseSelectField = ({
  data,
  isFetching,
  refetch,
  fetchErrMsg,
  fieldSettings,
}) => {
  const isError = data === 'Error';

  const setIsFetchError = useContext(
    contexts[contextNames.setIsFetchOptionsError]
  );

  useEffect(() => {
    setIsFetchError(isError);
  }, [isError, setIsFetchError]);

  return (
    <FetchDataWrapper
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg={fetchErrMsg}
    >
      <SelectField
        data={data}
        settings={fieldSettings}
        isFetching={isFetching}
      />
    </FetchDataWrapper>
  );
};

export default BaseSelectField;

function SelectField({ data, settings, isFetching }) {
  const control = useContext(contexts[contextNames.formControl]);

  const initialValue = useContext(contexts[contextNames.initialValue]);

  const { field, fieldState } = useFieldController({
    control,
    name: settings.name,
    rules: { validate: createValidateFn(initialValue) },
  });

  return (
    <Field.Memoized
      type={Field.types.select}
      formItemLabel={settings.label}
      required
      value={isFetching ? undefined : field.value}
      onChange={field.onChange}
      errorMessage={fieldState.error?.message}
      placeholder="Выбрать из списка"
      style={{ width: '100%' }}
    >
      {data?.map((item) => (
        <Select.Option value={item.id} key={item.id} disabled={!item.available}>
          {item.name}
        </Select.Option>
      ))}
    </Field.Memoized>
  );
}

function createValidateFn(initialValue) {
  return (value) => {
    if (value == null) {
      return 'Необходимо указать значение';
    }

    if (value === initialValue) {
      return 'Данные не изменены';
    }

    return true;
  };
}
